export default function Stat({ label, value }) {
  return (
    <div className="stat">
      <span>{label}</span>
      <strong>{value || 0}</strong>
    </div>
  );
}
